<!-- DropDownSplitButton.vue -->
<!-- This button has two parts -- the left side of the button is the default action, the right side displays an option menu -->
<script lang="ts" setup>
    import { computed } from 'vue';
    import { hasSlot } from '../lib/VueHelpers'
    import * as utils from '../lib/ChoiceUtils'

    const emits = defineEmits(["onButtonClick"]);

    const dropdownButtonId = `dropDownButton_${utils.randomId(6)}`;

    const props = withDefaults(defineProps<{
        buttonTitle?: string,
        dropDownButtonTitle?: string
        showDownArrow?: boolean,
        baseClass?: string,
        dropdownStyle?: string,
        disabled?: boolean,
        addMarginEnd?: boolean,
        onMouseEnterClass?: string,
        buttonGroupClass?: string
    }>(), {
        buttonTitle: "",
        dropDownButtonTitle: "Options",
        showDownArrow: true,
        baseClass: "btn btn-primary",
        dropdownStyle: "",
        disabled: false,
        addMarginEnd: true,
        onMouseEnterClass: "",
        buttonGroupClass: ""
    });

    // Computed
    const buttonClass = computed<string>(()=> props.baseClass);
    const toggleButtonIndicatorClass = computed<string>(() => props.showDownArrow ? " dropdown-toggle":" bg-light dropdown-toggle");
    const splitDropDownButtonClass = computed<string>(() => buttonClass.value + toggleButtonIndicatorClass.value + " dropdown-toggle-split");
    const showDropDownButton = computed(() => hasSlot() );
    const splitDropDownButtonDisabled = computed(() => {
        if (props.disabled || !props.showDownArrow) 
            return true;
        return false;
    });

    function onButtonClick() 
    {
        emits("onButtonClick");
    }

    const buttonGroupClass = computed<string[]>(()=>{
        return ["btn-group", props.buttonGroupClass, props.addMarginEnd ? "me-1" : ""];
    });

    function OnMouseEnter(event) 
    {
        if(!props.onMouseEnterClass && !props.disabled) return;
        const el = event.currentTarget;
        if (el) el.classList.add(props.onMouseEnterClass);
    }

    function OnMouseLeave(event)
    {
        if(!props.onMouseEnterClass && !props.disabled) return;
        const el = event.target;
        if (el) el.classList.remove(props.onMouseEnterClass);
    }

</script>

<template>
    <span  :class="buttonGroupClass" @mouseover="OnMouseEnter"  @mouseleave="OnMouseLeave">
        <button type="button" 
                :class="buttonClass"
                @click="onButtonClick"
                :title="buttonTitle"
                :disabled="disabled">
            <slot name="button">
                <i class="fa-solid fa-bolt-lightning" aria-hidden="true"></i>
            </slot>                
        </button>
        <button type="button" 
                :class="splitDropDownButtonClass" 
                style="opacity:.90"
                data-bs-toggle="dropdown" 
                aria-expanded="false" 
                :title="dropDownButtonTitle"
                :disabled="splitDropDownButtonDisabled"
                v-if="showDropDownButton">
        </button>
        <ul class="dropdown-menu" :style="dropdownStyle" v-if="showDropDownButton">
            <slot>
                <span class="color:red">No dropdown items</span>
            </slot>
        </ul>
    </span>

</template>